module.exports = __webpack_public_path__ + "img/xiaofang.b9087b21.png";